import axios from 'axios'

import store from 'store'
import { AUTH__LOGIN_REFRESH, AUTH__LOGOUT } from 'store/actions'
import { REFRESH } from '../../auth'

export const BASE_URL = process.env.REACT_APP_BACKEND_URL

const INSTANCE = axios.create({
    headers: {
        'Access-Control-Allow-Origin': '*',
    },
    baseURL: `${BASE_URL}/api`,
    timeout: 30000,
})
INSTANCE.interceptors.request.use(
    config => {
        const { token, language, user } = store.getState()
        config.headers['Accept-Language'] = language

        if (user && user.optionalId) config.headers['X-User-Id'] = user.optionalId
        if (token) config.headers['Authorization'] = `${token.type} ${token.access}`

        return config
    },
    err => {
        return Promise.reject(err)
    },
)
INSTANCE.interceptors.response.use(
    async res => {
        return res.data
    },
    async err => {
        const isTokenExpired = isAccessTokenExpiredOrInvalid(err)
        if (isTokenExpired && !isRefreshingToken) {
            const isSuccessful = await refreshToken()
            if (isSuccessful) {
                flushWaitingRequests()
                return Promise.resolve(INSTANCE(err.config))
            }

            cleanWaitingRequest()
            return Promise.reject(err)
        }
        if (isTokenExpired && isRefreshingToken) {
            return new Promise(resolve => {
                addToQueue(() => {
                    resolve(INSTANCE(err.config))
                })
            })
        }

        return Promise.reject(err)
    },
)

function isAccessTokenExpiredOrInvalid({ config, response: { status, data } }) {
    return !config.url.includes('/oauth/token') && status === 401 && data.error === 'invalid_token'
}

let isRefreshingToken = false
let waitingRequests = []

async function refreshToken() {
    const {
        token: { refresh },
        user: { optionalId },
    } = store.getState()
    isRefreshingToken = true
    try {
        const newTokenResponse = await REFRESH(refresh)
        store.dispatch(AUTH__LOGIN_REFRESH(newTokenResponse, optionalId ? optionalId : null))
        return true
    } catch (err) {
        store.dispatch(AUTH__LOGOUT())
        return false
    } finally {
        isRefreshingToken = false
    }
}

function flushWaitingRequests() {
    waitingRequests.forEach(callback => callback())
    waitingRequests = []
}

function cleanWaitingRequest() {
    waitingRequests = []
}

function addToQueue(callback) {
    waitingRequests.push(callback)
}

export default INSTANCE
